import { Form, FormCheck } from 'react-bootstrap'
import styled from 'styled-components'
import colors from '../constants/colors'
import styles from '../constants/styles'

const S = {
    Sidebar: styled.div<{isShowSidebar?: boolean}>`
        display: flex;
        flex-direction: column;
        background: white;
        width: ${styles.sidebarWidth}px;
        height: 100%;
        padding-top: ${styles.topNavHeight}px;
        position: fixed;
        top: 0;
        right: ${({ isShowSidebar = true }) => (isShowSidebar ? 0 : -(styles.sidebarWidth))}px;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
        transition: 0.75s;
        @media (max-width: 1366px) {
            width: ${styles.smallerSidebarWidth}px;
            right: ${({ isShowSidebar = true }) => (isShowSidebar ? 0 : -(styles.smallerSidebarWidth))}px;
        }
    `,
    SideBarTop: styled.div`
        flex-shrink: 0;
        background: ${colors.mineShaft};
        width: 100%;
        padding: 10px;
    `,
    SideBarTitle: styled.h3`
        color: white;
        font-size: 20px;
        font-weight: 500;
        text-transform: uppercase;
        margin: 20px 10px 10px 0;
        overflow: hidden;
    `,
    UserWrapper: styled.div`
        display: flex;
        justify-content: space-between;
    `,
    UserInfo: styled.div`
        width: 270px;
        & .general-info-wrapper {
            background-color: transparent!important;
            & .general-info-name {
                color: white;
            }
        }
        @media (max-width: 1366px) {
            width: 200px;
        }
    `,
    ToggleWrapper: styled(Form.Group)`
        display: flex;
        flex-direction: column;
        text-align: right;
        color: white;
    `,
    ToggleLabel: styled.div`
        font-size: 12px;
    `,
    Toggle: styled(FormCheck)`
        margin-left: auto;
        margin-top: 5px;
        transform: scale(1.6);
    `,
    InputGroup: styled.div`
        position: relative;
        padding-top: 10px;
    `,
    SearchIcon: styled.div`
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-33%);
    `,
    SidebarContent: styled.div`
        overflow: auto;
    `,
    SidebarContentTitle: styled.h3`
        margin: 20px 10px;
        font-size: 16px;
        font-weight: 500px;
        color: #42454A;
    `
}

export default S
